import { Grid } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardInfobox } from "@/dashboard-design-system/Infobox";

interface UnsubscribeEmailWarningProps {
  unsubscribeEmails: string[];
}

export const UnsubscribeEmailWarning = ({ unsubscribeEmails }: UnsubscribeEmailWarningProps) => {
  const { t } = useTranslate();
  return (
    <Grid item xs={12} marginTop={1}>
      <DashboardInfobox vibe="warning" size="small" type="alert">
        <Grid container justifyContent="space-between">
          <Grid item alignContent="center">
            {t("dashboard", "emailRecipientInput.emailWontBeSentTo")}
            {unsubscribeEmails.length === 1 && (
              <>
                <strong>
                  {t("dashboard", "emailRecipientInput.emailWontBeSentToEmail1", { email: unsubscribeEmails[0] })}
                </strong>
                {t("dashboard", "emailRecipientInput.emailWontBeSentToEmailBecause1")}
              </>
            )}
            {unsubscribeEmails.length === 2 && (
              <>
                <strong>
                  {t("dashboard", "emailRecipientInput.emailWontBeSentToEmail2", {
                    email1: unsubscribeEmails[0],
                    email2: unsubscribeEmails[1],
                  })}
                </strong>
                {t("dashboard", "emailRecipientInput.emailWontBeSentToEmailBecause2")}
              </>
            )}
            {unsubscribeEmails.length === 3 && (
              <>
                <strong>
                  {t("dashboard", "emailRecipientInput.emailWontBeSentToEmail3", {
                    email1: unsubscribeEmails[0],
                    email2: unsubscribeEmails[1],
                  })}
                </strong>
                {t("dashboard", "emailRecipientInput.emailWontBeSentToEmailBecause2")}
              </>
            )}
            {unsubscribeEmails.length > 3 && (
              <>
                <strong>
                  {t("dashboard", "emailRecipientInput.emailWontBeSentToEmail4", {
                    email1: unsubscribeEmails[0],
                    email2: unsubscribeEmails[1],
                    count: unsubscribeEmails.length - 2,
                  })}
                </strong>
                {t("dashboard", "emailRecipientInput.emailWontBeSentToEmailBecause2")}
              </>
            )}
          </Grid>
        </Grid>
      </DashboardInfobox>
    </Grid>
  );
};
